<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->


<template>
  <div class="wy-interactions-dashboard-table-detail-topic-relations" v-loading="loading">
    <div class="topic-contact-main-section" v-if="!showTopicContent||(relatedTopic&&relatedTopic.length>0)">
      <div class="topic-group-section">
        <div class="div-group-viewer-header div-group-name">
          Topic Category
        </div>
        <div class="div-group-viewer-content" v-loading="topicLoading">
          <div class="div-group-topics">
            <div class="div-topic-content">
              <div v-for="(topic, index) in relatedTopicList" :label="topic.relatedTopic" :key="index"
                v-bind:class="{ 'div-item': true, selected: topic && topic.selected }"
                @click="getContactsByTopic(topic, 0, $event)">
                <div :title="topic.relatedTopic" class="div-ellipsis-item">{{ topic.relatedTopic }}</div>
                <div class="div-total" @mouseover="mouseover($event, topic.total, '')" @mouseout="mouseout">({{ formatterNumber(topic.total) }})</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="interactions-contacts-section">
        <div v-if="!showMessageContent||topicMessages.length>0">
          <div class="div-topic-messages-viewer-header">Contact ID</div>
          <div class="content-wrapper" v-loading="loadingMsg">
            <div class="div-topic-messages-viewer-content">
              <div ref="conversationMessages" class="div-topic-message-name" v-for="(item, index) in topicMessages" :key="index"
                v-bind:class="{ selected: (selectedMessage && selectedMessage.conversationId == item.conversationId) }">
                <div class="div-item-row">
                  <div class="col-left">
                    <div class="message-contact-id" @click="handleOpenMediaPlayer(item.conversationId)">{{ item.conversationId }}</div>
                    <div class="message-date">{{ formatMessageHeaderDate(item.date) }}</div>
                  </div>
                  <div class="col-right">
                    <div class="message-contact-name">{{ item.agentFirstName }} {{ item.agentLastName }}</div>
                    <div class="message-date-time">{{ item.msgTime }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showMessageContent&&topicMessages.length>0" class="div-group-viewer-footer div-group-name">
              <div class="div-message-transcripts-viewer-footer">
                <div class="div-transcript-page-infor">Showing {{ pageItemStart }}-{{ pageItemEnd }}</div>
                <div class="div-transcript-pagination">
                  <el-pagination :page-size="pageSize" :page-count="pageCount" :current-page="pageNo" :disabled="loadingMsg" prev-text="< Previous"
                    next-text="Next >" @current-change="pageChanged" layout="prev, next">
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
          
        <div v-else class="contact-section div-no-data">
          <div class="no-data-message"></div>
        </div>
      </div>
    </div>
    
    <div v-else class="main-panel div-no-data">
      <div class="no-data-message"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import WyUtils from '../../../library/wy-utils.js';

export default Vue.extend({
  name: 'wy-interactions-dashboard-table-detail-topic-relations',
  props: ['parent', 'activeTab'],

  data() {
    return {
      loading: false,
      topicLoading: false,
      loadingMsg: false,
      loadingTranscriptMsg: false,
      initDate: null,
      relatedTopic: [],
      tagData: {},
      topicMessages: [],
      selectedMessage: null,
      topicMessagesTranscripts: [],
      updatedTimestamp: (new Date()).getTime(),
      showTopicContent: false,
      showMessageContent: false,

      pageNo: 1,
      pageSize: 100,
      pageCount: 1,
      pageItemStart: 0,
      pageItemEnd: 0,
      fetchData: true
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'isRoleAllow', 'processList', 'tokenInfo']),

    relatedTopicList() {
      return this.relatedTopic;
    }
  },

  methods: {
    ...mapActions(['fetchRelatedTopics', 'fetchContactReasonsRelatedTopicConversations']),
    ...mapMutations(['updateTranscriptInfoReference']),

    pageChanged(pageNo) {
      const selectedTopic = this.relatedTopicList.find(el => el && el.selected);
      if (selectedTopic) {
        this.getContactsByTopic(selectedTopic, pageNo);
      }
    },

    handleTimeInNiceFormat(Millis) {
      let seconds = Millis / 1000;
      return WyUtils.toNiceTimeFormat(seconds);
    },

    formatterNumber(value) {
      return WyUtils.formatterNumber(value);
    },

    async startLoading() {
      this.initDate = new Date();
      if (!this.loading) {
        this.logEventLoaded();
      }
      await this.loadTopicGroup();
    },

    logEventLoaded() {
      if (this.initDate) {
        this.initDate = null;
      }
    },

    toTranscriptLabel(val) {
      return WyUtils.toTranscriptLabel(val);
    },

    formatMessageDate(date) {
      return WyUtils.formatDate(date);
    },

    formatMessageHeaderDate(date) {
      return WyUtils.formatDateWithDay(date);
    },

    getTimeRange(transcript) {
      if(transcript.startDateTime && transcript.endDateTime) {
        let sTime = WyUtils.dateTimeValidation(transcript.startDateTime)
        let eTime = WyUtils.dateTimeValidation(transcript.endDateTime)
        let startTime = moment(sTime).format("h:mm a");
        let endTime = moment(eTime).format("h:mm a");
        return startTime + ' - ' + endTime;
      }
      else {
        return 'Invalid time';
      }
    },

    handleOpenMediaPlayer(conversationId) {
      if(this.tokenInfo && this.tokenInfo.authHost) {
        const mediaLink = `https://${this.tokenInfo.authHost}/#/recordings/${conversationId}/ccr/player`
        window.open(mediaLink);
      }
    },

    async getContactsByTopic(topic, pageNo) {
      this.relatedTopicList.map(el => { el.selected = false });
      if (topic) topic.selected = true;

      if (pageNo) {
        this.pageNo = pageNo;
      }
      else {
        this.pageNo = 1;
        this.pageItemStart = 0;
        this.pageItemEnd = 0;
        this.pageCount = 1;
      }
      this.topicMessages = [];
      this.showMessageContent = false;

      this.loadingMsg = true;
      const result = await this.fetchContactReasonsRelatedTopicConversations({ 
        topicDisplayName: this.parent.currentItem.topicDisplayName, 
        topics: this.parent.currentItem.mergedTopics, 
        relatedTopic: topic.relatedTopic, 
        isOthers: this.parent.currentItem.isOthers,
        pageNo: this.pageNo, 
        pageSize: this.pageSize + 1
      })
      if (result && result.data && result.data.length > 0) {
        if (result.data.length > this.pageSize) {
          this.topicMessages = result.data.slice(0, result.data.length - 1);
          this.pageItemStart = (this.pageNo - 1) * (this.pageSize + 1) + 1;
          this.pageItemEnd = this.pageItemStart + this.pageSize;
          this.pageCount = this.pageNo + 1;
        }
        else {
          this.topicMessages = result.data;
          this.pageItemStart = (this.pageNo - 1) * (this.pageSize) + 1;

          this.pageItemEnd = this.pageItemStart + result.data.length - 1;
        }
      }
      else {
        this.topicMessages = [];
        this.pageNo = 1;
        this.pageItemStart = 0;
        this.pageItemEnd = 0;
      }
      
      this.loadingMsg = false;
      setTimeout(() => {
        this.showMessageContent = true;
      }, 300);
    },

    async loadTopicGroup() {
      if (this.fetchData && this.parent.currentItem) {
        this.topicLoading = true;
        this.loadingMsg = true;
        this.fetchData = false;
        this.showTopicContent = false
        this.showMessageContent = false;
        this.tagData = this.parent.currentItem;
        const result = await this.fetchRelatedTopics({ 
          topicDisplayName: this.parent.currentItem.topicDisplayName, 
          topics: this.parent.currentItem.mergedTopics,
          isOthers: this.parent.currentItem.isOthers,
        })
        this.relatedTopic = result.data;
        if( this.relatedTopic &&  this.relatedTopic.length > 0) {
           this.getContactsByTopic(this.relatedTopic[0], 0);
        }
        this.topicLoading = false;
        this.showTopicContent = true;
      }
      this.parent.stopLoadingByTab('groupedTopics');
    },

    mouseover(e, tooltips) {
      e.stopPropagation();
      let tooltipsEl = document.querySelector(".site-tooltips");
      if(tooltipsEl) {
        tooltipsEl.classList.add('black-background');
        tooltipsEl.classList.add('bottom-arrow');
        tooltipsEl.innerHTML = this.formatterNumber(tooltips);
        tooltipsEl.style.display = 'block';
        tooltipsEl.style.left = `${e.target.getBoundingClientRect().x + 10}px`;
        tooltipsEl.style.top = `${e.target.getBoundingClientRect().top + e.target.getBoundingClientRect().height - 55}px`;
        tooltipsEl.style.left = `${e.target.getBoundingClientRect().x - tooltipsEl.getBoundingClientRect().width / 2 + e.target.getBoundingClientRect().width / 2 + 25}px`;
      }
    },
    mouseout(e) {
      e.stopPropagation();
      let tooltipsEl = document.querySelector(".site-tooltips");
      if(tooltipsEl) {
        tooltipsEl.style.display = 'none';
        tooltipsEl.classList.remove('bottom-arrow');
      }
    }
  },

  created() {
    this.loadTopicGroup();
  }
});
</script>

<style lang="scss">
.wy-interactions-dashboard-table-detail-topic-relations {
  // display: inline-flex;
  width: 100%;
  height: calc(100vh - 287px);
  min-width: 1000px;
  // min-width: 1176px;
  .topic-contact-main-section {
    display: inline-flex;
    width: 100%;
    height: calc(100vh - 287px);
    min-width: 1000px;
  }

  .transcripts-viewer-header-right {
    overflow-y: auto;
    height: 204px !important;
    padding-right: 20px;

    &::-webkit-scrollbar {
      background-color: #000 !important;
      width: 8px !important;
    }

    &::-webkit-scrollbar-thumb {
      background: #C8C8C8 !important;
      border-radius: 5px;
    }
  }


  .sentiment-icon-positive {
    cursor: pointer;
    background-image: url('../../../assets/icons/icon_positive_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .sentiment-icon-neutral {
    cursor: pointer;
    background-image: url('../../../assets/icons/icon_neutral_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .sentiment-icon-negative {
    cursor: pointer;
    background-image: url('../../../assets/icons/icon_negative_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }


  .topic-group-section {
    min-width: 540px;
    max-width: 540px;
    margin-right: 15px;
    margin-bottom: 20px;
    width: 25%;
    padding: 10px 0px 10px 0px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 10px;
    opacity: 1;

    .div-group-viewer-content {
      margin-top: 10px;
      border-top: 1px solid #E8E8E8;
      height: calc(100vh - 355px);
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 12px;

      &::-webkit-scrollbar {
        width: 20px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 160px;
        border: 2px solid transparent;
        border-top: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#F3F6F8;
        border-top: 1px solid #CAD2DA;
        border-bottom-right-radius: 8px !important;

      }
      &::-webkit-scrollbar:vertical {
        width: 14px;
      }
      &::-webkit-scrollbar-thumb:vertical {
        border-radius: 160px;
        border: 2px solid transparent;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track:vertical {
        // border-left: 1px solid #CAD2DA;
        border-top: none !important;
      }

    }

    .div-group-viewer-header.div-group-name {
      font-size: 16px;
      font-weight: 500;
      padding: 0px 10px 5px 30px;
    }

    .div-group-topics {
      margin-top: 0px;

      .div-topic-content {
        height: fit-content;

        .div-item {
          color: var(--site-font-primary-color);
          font-weight: normal;
          margin: 0px 0px 0px 0px;
          line-height: 19px;
          padding: 9px 20px 3px 30px;
          font-size: 12px;
          // width: 88%;
          white-space: nowrap;
          overflow: hidden;
          // text-overflow: ellipsis;
          cursor: pointer;

          .div-ellipsis-item {
            width: calc(100% - 100px);
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 20px;
          }
          .div-total {
            display: inline-block;
            width: 50px;
            text-align: right;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 10px;
          }

          button {
            width: 15px;
            height: 15px;
            border: 0;
            padding: 0;
            margin: 0;
            background-color: #fff;

            .el-icon-error {
              top: -3px;
            }
          }
        }

        .div-item:hover {
          background: #f5f7fa;
        }

        .div-item.selected {
          background: #E2ECF7;

          button {
            background-color: #E2ECF7;
          }
        }

        .div-item.disabled {
          button {
            opacity: 0.3 !important;
            cursor: default;

            .el-icon-error {
              cursor: default;
            }
          }
        }

        .el-icon-error {
          float: right;
          // display: none;
          top: 2px;
          position: relative;
          color: #80A6CD;
          cursor: pointer;
          font-size: 15px;
        }

        .el-icon-error.is-disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }

        .div-item:hover .el-icon-error {
          display: block;
        }
      }
    }
  }

  .interactions-contacts-section {
    margin-bottom: 20px;
    width: 75%;
    padding: 7px 0px 10px 0px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;

    .el-loading-mask {
      height: unset !important;
      opacity: unset;
      background-color: unset;

      .el-loading-spinner {
        top: 35%;
        background: var(--site-loading-icon);
        background-repeat: no-repeat;
        background-size: 25px;
        background-position: center;
      }

      .el-loading-spinner .circular {
        display: unset !important;
      }
    }

    .div-topic-messages-viewer-header {
      font-size: 16px;
      font-weight: 500;
      padding: 4px 10px 9px 30px;
    }

    .div-topic-messages-viewer-content {
      margin-top: 5px;
      border-top: 1px solid #E8E8E8;
      border-bottom: 1px solid #E8E8E8;
      height: calc(100vh - 384px);
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 5px;
      //padding-top: 10px;

      .div-topic-message-name {
        font-size: 12px;
        word-break: keep-all;
        color: var(--site-font-primary-color);
        font-weight: normal;
        margin: 0px 0px 0px 0px;
        line-height: 12px;
        padding: 12px 10px 11px 30px;

        .div-item-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          display: flex;
          padding: 15px 0px;
          justify-content: space-between;

          .col-left,.col-right {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 40px;
          }

          .message-contact-id {
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            text-decoration-line: underline;
            text-decoration-style: solid;
            cursor: pointer;
          }
          .message-date {
            width: 105px;
            display: inline-block;
          }

          .message-contact-name {
            font-weight: 500;
            text-align: right;
          }

          .message-right {
            float: right;
            width: 130px;

            .message-date-time {
              text-align: left;
              padding-right: 10px;
            }
          }
        }
      }

      .div-topic-message-name:hover {
        // background: #f5f7fa;
        background: #E2ECF7;
      }

      .div-topic-message-name.selected {
        background: #E2ECF7;
      }
      
      &::-webkit-scrollbar {
        width: 20px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 160px;
        border: 2px solid transparent;
        border-top: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#F3F6F8;
        border-top: 1px solid #CAD2DA;
      }
      &::-webkit-scrollbar:vertical {
        width: 14px;
      }
      &::-webkit-scrollbar-thumb:vertical {
        border-radius: 160px;
        border: 2px solid transparent;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track:vertical {
        // border-left: 1px solid #CAD2DA;
        border-top: none !important;
      }

    }
    .content-wrapper.el-loading-parent--relative {
      height: calc(100vh - 360px);
      border-top: 1px solid #E8E8E8;
      margin-top: 5px;
    }
    .contact-section.div-no-data {
      display: flex;
      width: 100%;
      height: calc(100% - 100px);
      justify-content: space-around;
      align-items: center;
      .no-data-message {
        text-align: center;
        padding: 20px 0;
        font-size: 14px;
        // color: #ADADAD;
        background-image: url('../../../assets/brands/st/icons/icon_smart_tags_no-data.png');
        background-size: 100%;
        background-repeat: no-repeat;
        height: 200px;
        width: 300px;
      }
    }
  }

  .message-transcripts-section {
    padding: 7px 0px 0px 0px;
    margin-bottom: 20px;
  }

  .div-group-viewer-footer.div-group-name {
    font-size: 16px;
    font-weight: 500;
    padding: 0px 0px 0px 0px;
  }

  .div-message-transcripts-viewer-footer {
    display: inline-block;
    width: 100%;

    .div-transcript-page-infor {
      float: left;
      padding-top: 2px;
      padding-left: 14px;
      font-size: 12px;
      color: #ADADAD;
    }

    .div-transcript-pagination {
      float: right;
      padding-right: 14px;
      font-size: 12px;
      color: #ADADAD;

      .el-pagination {
        padding-right: 0px;
      }

      .el-pagination button {
        color: #002852;
        font-weight: bold;
        padding-right: 0px;
        padding-left: 30px;
        font-size: 12px;
        line-height: unset !important;
        height: unset !important;

        >span {
          line-height: unset !important;
          height: unset !important;
        }
      }

      .el-pagination button.btn-next {
        padding-left: 10px;
      }

      .el-pagination button:disabled {
        color: #C0C4CC;
      }

      .el-pagination span:not([class*=suffix]) {
        word-spacing: 7px;
      }
    }
  }

  .main-panel.div-no-data {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-around;
    align-items: center;
    .no-data-message {
      text-align: center;
      padding: 20px 0;
      font-size: 14px;
      // color: #ADADAD;
      background-image: url('../../../assets/brands/st/icons/icon_smart_tags_no-data.png');
      background-size: 100%;
      background-repeat: no-repeat;
      height: 500px;
      width: 400px;
    }
  }
}

.site-tooltips.bottom-arrow:after {
  transform: rotateZ(180deg);
  bottom: 0%;
  top: 95%;
  left: 20% !important;
}
</style>